import { Controller } from "@hotwired/stimulus"

// When start time changes, adjusts end time to preserve duration.
// Toggles recurrence fields based on selected recurrence type.
export default class extends Controller {
  static targets = [
    "startTimeInput",
    "endTimeInput",
    "recurrenceType",
    "recurrenceEndPanel",
    "recurrenceCustomPanel",
    "recurrenceWeekdaysPanel",
    "recurrenceFrequencyUnit",
    "recurrenceWeekday"
  ]

  connect() {
    this.toggleRecurrenceFields()
    this.syncWeekdayFromStartTime()
  }

  adjustEndTime() {
    if (!this.hasStartTimeInputTarget || !this.hasEndTimeInputTarget) return

    const startInput = this.startTimeInputTarget
    const endInput = this.endTimeInputTarget

    const startValue = startInput.value
    const endValue = endInput.value

    if (!startValue) return

    const start = new Date(startValue)
    if (Number.isNaN(start.getTime())) return

    const end = endValue ? new Date(endValue) : start
    let durationMs = Number.isNaN(end.getTime()) ? 0 : end.getTime() - start.getTime()

    if (durationMs <= 0) durationMs = 60 * 60 * 1000

    const newEnd = new Date(start.getTime() + durationMs)
    endInput.value = this.formatDateTimeLocal(newEnd)

    this.syncWeekdayFromStartTime()
  }

  toggleRecurrenceFields() {
    if (!this.hasRecurrenceTypeTarget) return

    const type = this.recurrenceTypeTarget.value
    const showRecurrence = type !== "none"
    const showCustom = type === "custom"
    const showWeekdays = showCustom && this.hasRecurrenceFrequencyUnitTarget &&
      this.recurrenceFrequencyUnitTarget.value === "weeks"

    if (this.hasRecurrenceEndPanelTarget) {
      this.togglePanel(this.recurrenceEndPanelTarget, showRecurrence)
    }
    if (this.hasRecurrenceCustomPanelTarget) {
      this.togglePanel(this.recurrenceCustomPanelTarget, showCustom)
    }
    if (this.hasRecurrenceWeekdaysPanelTarget) {
      this.togglePanel(this.recurrenceWeekdaysPanelTarget, showWeekdays)
    }
  }

  syncWeekdayFromStartTime() {
    if (!this.hasStartTimeInputTarget || !this.hasRecurrenceWeekdayTarget) return

    const startValue = this.startTimeInputTarget.value
    if (!startValue) return

    const start = new Date(startValue)
    if (Number.isNaN(start.getTime())) return

    const weekday = this.weekdayNameForDate(start)
    const anyChecked = this.recurrenceWeekdayTargets.some((checkbox) => checkbox.checked)
    if (anyChecked) return

    this.recurrenceWeekdayTargets.forEach((checkbox) => {
      checkbox.checked = checkbox.value === weekday
    })
  }

  weekdayNameForDate(date) {
    const names = ["sunday", "monday", "tuesday", "wednesday", "thursday", "friday", "saturday"]
    return names[date.getDay()]
  }

  togglePanel(panel, visible) {
    if (!panel) return

    panel.classList.toggle("hidden", !visible)
  }

  formatDateTimeLocal(date) {
    const pad = (n) => n.toString().padStart(2, "0")
    return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}T${pad(date.getHours())}:${pad(date.getMinutes())}`
  }
}
